import clsx from 'clsx';
import React from 'react';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { showToast } from '@/src/globalFunction';

import { useValidateActionResponse } from '../../../../../useValidateActionResponse';
import { useFileEntryViewerSidebarActions } from '../../../../store/fileEntryViewer.sidebarActions.store';

type MarkReadFileProps = {
  isRead: boolean;
};

const MarkReadFile = ({ isRead }: MarkReadFileProps) => {
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const markReadMutation = sidebarActions.markReadMutation;
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(markReadMutation.data) ? markReadMutation.data : null,
  });

  const label = isRead ? 'unread' : 'read';
  const icon = isRead
    ? 'mail_outline'
    : ICONS.email_read({
        fillClassName: '!tw-fill-cfo-black group-hover:!tw-fill-cfo-blue-600',
      });
  const handleClick = async () => {
    const response = await markReadMutation.mutateAsync({
      read: !isRead,
    });

    if (response) {
      showToast('success', `File successfully marked as ${label}.`);
    }
  };

  return (
    <React.Fragment>
      <ActionButton
        id={'read_document'}
        className={clsx('tw-w-full', 'tw-justify-between')}
        onClick={handleClick}
        label={`Mark as ${label}`}
        icon={icon}
      />
      {confirmRefreshModal}
    </React.Fragment>
  );
};

export default MarkReadFile;
